import { IPaymantPayload } from '@/interface'
import { post } from '@/utils'
export interface IPaymantBreakdownPayload {
  senderAddress: string
  receiverAddress: string
}
class Merchant {
  GetDataToSign = (payload: IPaymantPayload) => post('/pay/create/', payload)
  CreateQROrder = async (payload: any) => post('/pay/create-qr-order', payload)
}
export const MerchantService = new Merchant()
